<template>
    <!--@formatter:off-->
    <div>
        <SurveyQuestionEditor
            ref="counselTypeQuestionEditor"
            :question="questions[0]"
            :is-use-start-question-number="false"
            :question-index="0"
            :siblings-count="0"
            :is-show-type="false"
            :is-show-options="false"
            :is-show-answer-image="false"
            :is-show-answer-sub-question="false"
            :is-show-operation="false"
        >
            <template v-slot:header="{
                isUseQuestion,
                setUseQuestion,
            }">
                <div class="tit_q_input">
                    <strong class="tit">{{$t('SurveyQuestionEditorParentCounselWeek_counselType')}}<span class="txt">{{$t('SurveyQuestionEditor_singleChoice')}}</span></strong>
                    <!-- slot prop으로 setter가 있는 computed를 받아도 setter가 동작하지 않는다
                        set함수를 별도로 받아 처리 함 -->
                    <SwitchButton
                        :label="$t('SurveyQuestionEditorParentCounselWeek_isUseQuestion')"
                        :value="isUseQuestion"
                        @input="setUseQuestion"
                    />
                </div>
            </template>
        </SurveyQuestionEditor>

        <SurveyQuestionEditorParentCounselWeekTime
            :question="questions[1]"
            :is-use-start-question-number="false"
            :question-index="calcQuestionIndex(1)"
            :siblings-count="0"
        />

        <SurveyQuestionEditor
            :question="questions[2]"
            :is-use-start-question-number="false"
            :question-index="calcQuestionIndex(2)"
            :siblings-count="0"
            :show-types="['ONE_CHOICE', 'MULTI_CHOICE', 'TEXT']"
            :is-show-options="false"
            :is-show-answer-image="false"
            :is-show-answer-sub-question="false"
            :is-show-operation="false"
        >
            <template v-slot:header="{
                    isUseQuestion,
                    setUseQuestion,
                }">
                <div class="tit_q_input">
                    <strong class="tit">{{$t('SurveyQuestionEditorParentCounselWeek_counselAgenda')}}</strong>
                    <!-- slot prop으로 setter가 있는 computed를 받아도 setter가 동작하지 않는다
                        set함수를 별도로 받아 처리 함 -->
                    <SwitchButton
                        :label="$t('SurveyQuestionEditorParentCounselWeek_isUseQuestion')"
                        :value="isUseQuestion"
                        @input="setUseQuestion"
                    />
                </div>
            </template>
        </SurveyQuestionEditor>

        <SurveyQuestionEditor
            :question="questions[3]"
            :is-use-start-question-number="false"
            :question-index="calcQuestionIndex(3)"
            :siblings-count="0"
            :is-show-type="false"
            :is-show-operation="false"
        >
            <template v-slot:header="{
                    isUseQuestion,
                    setUseQuestion,
                }">
                <div class="tit_q_input">
                    <strong class="tit">{{$t('SurveyQuestionEditorParentCounselWeek_additional')}}<span class="txt">{{$t('SurveyQuestionEditor_subjective')}}</span></strong>
                    <!-- slot prop으로 setter가 있는 computed를 받아도 setter가 동작하지 않는다
                        set함수를 별도로 받아 처리 함 -->
                    <SwitchButton
                        :label="$t('SurveyQuestionEditorParentCounselWeek_isUseQuestion')"
                        :value="isUseQuestion"
                        @input="setUseQuestion"
                    />
                </div>
            </template>
        </SurveyQuestionEditor>
    </div>
    <!--@formatter:on-->
</template>

<script>
import SurveyQuestionEditor from '@iamteacherpc/components/editor/SurveyQuestionEditor.vue';
import SurveyQuestionEditorParentCounselWeekTime
    from '@iamteacherpc/components/editor/SurveyQuestionEditorParentCounselWeekTime.vue';
import SwitchButton from '@iamteacherpc/components/common/SwitchButton.vue';

export default {
    name: "SurveyQuestionEditorParentCounselWeek",
    components: {SwitchButton, SurveyQuestionEditorParentCounselWeekTime, SurveyQuestionEditor},
    extends: SurveyQuestionEditor,

    methods: {
        focusQuestion() {
            this.$refs.counselTypeQuestionEditor.focusQuestion();
        },

        calcQuestionIndex(index) {
            const notUseQuestionCount = this.questions
                .slice(0, index)
                .filter(q => !q.isUseQuestion)
                .length;

            return index - notUseQuestionCount;
        },
    },
}
</script>

<style scoped>
</style>